import { app } from '../../../../bootstrap/core';
import { financeListComponent } from './financeList.component';
import './financeProperty/financeProperty';

app.component('financeList', financeListComponent);
